module.exports = __webpack_public_path__ + "img/kayak003.f77ae337.jpg";